import WebAudioFileAdapter from '@Infra/AudioFile/WebAudioFileAdapter';
import WebCaptureAdapter from '@Infra/Capture/WebCaptureAdapter';
import WebConnectivityAdapter from '@Infra/Connectivity/WebConnectivityAdapter';
import WebFullscreenAdapter from '@Infra/Fullscreen/WebFullscreenAdapter';
import IndexedDbLocalBufferAdapter from '@Infra/LocalBuffer/IndexedDbLocalBufferAdapter';
import IndexedDbLocalInterviewStore from '@Infra/LocalInterviews/IndexedDbLocalInterviewStore';
import WebDeviceNotificationAdapter from '@Infra/Notification/WebDeviceNotificationAdapter';
import OutboxRunner from '@Infra/Outbox/OutboxRunner';
import WebScreenWakeAdapter from '@Infra/ScreenWake/WebScreenWakeAdapter';
import type { DevicePorts } from '@Domain/Ports/DevicePorts';

/**
 * The single place where the web adapters behind the nine device ports are chosen — the door to
 * native: a Capacitor container would only ever change this file. Building a port never opens
 * anything by itself, so building the nine defaults here, once per call, is safe even where the
 * underlying browser surface (IndexedDB, Web Locks, Notification, the service worker container...)
 * is absent, as it is under jsdom.
 */
const resolveDevicePorts = (): DevicePorts => ({
	capture: new WebCaptureAdapter(),
	localBuffer: new IndexedDbLocalBufferAdapter(),
	localInterviews: new IndexedDbLocalInterviewStore(),
	outbox: new OutboxRunner(),
	connectivity: new WebConnectivityAdapter(),
	notification: new WebDeviceNotificationAdapter(),
	screenWake: new WebScreenWakeAdapter(),
	audioFile: new WebAudioFileAdapter(),
	fullscreen: new WebFullscreenAdapter(),
});

export default resolveDevicePorts;
